import {axios} from 'marmot_design_ui'

export const getAppInfoApi = (navUrl?:string) => {
    return axios.request({
      url: navUrl || "/leco/ecology/api/v1/menu/getTopBarInfo",
      method: "get",
    });
}
// 页面顶部用户信息
export const getLoginUserInfo = () => {
  return axios.request({
      url: '/phoenix/portal/api/v2/pc/loginUser/getLoginUserInfo',
      method:"get",
  })
}
export const getAppMenuApi = ({appName='',leftMenuApi=''}) => {
  return axios.request({ 
    url: leftMenuApi||"/shiyan/fitness/api/v1/fitnessMember/menu/getFunctionItems",
    method: "get",
    noLoading : true,
    params:{appName}
  });
}